<div style="margin: 10px 10px 10px 10px;">

	<port-enable-disable-editor [ifTableHeightVh]="100" [ifTableHeightPx]="-510" [ifTableMinHeight]="150">
	</port-enable-disable-editor>

</div>
